import React, { useEffect, useState } from "react";
import { Megaphone, ExternalLink } from "lucide-react";
import api from "@/lib/api";
import WhatsAppIcon from "@/components/WhatsAppIcon";

const resolveImg = (url) => (url && url.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url);

export default function PromoOffersWidget({ context = "public" }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/promo-offers").then((res) => setData(res.data)).catch(() => {});
  }, []);

  if (!data) return null;
  const enabled = context === "agent" ? data.agent_track_enabled : data.public_track_enabled;
  const offers = data.offers || [];
  if (!enabled || offers.length === 0) return null;

  return (
    <section data-testid="promo-offers-widget" className="max-w-4xl mx-auto px-4 sm:px-6 pb-10">
      <p className="font-heading font-bold text-gray-900 mb-4 flex items-center gap-2">
        <Megaphone size={16} className="text-[#b1976b]" /> {data.heading || "Offers & Announcements"}
      </p>
      <div className={`grid gap-4 ${offers.length === 1 ? "grid-cols-1" : "sm:grid-cols-2"} ${offers.length > 2 ? "lg:grid-cols-3" : ""}`}>
        {offers.map((o) => {
          const card = (
            <div key={o.id} data-testid={`promo-offer-${o.id}`} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden h-full flex flex-col hover:shadow-md transition-shadow">
              {o.image_url && <img src={resolveImg(o.image_url)} alt={o.title} className="w-full h-36 object-cover" />}
              <div className="p-4 flex-1">
                <p className="font-semibold text-gray-900 text-sm flex items-center gap-1.5">{o.title}{o.link && <ExternalLink size={12} className="text-gray-400" />}</p>
                {o.description && <p className="text-xs text-gray-500 mt-1">{o.description}</p>}
                {o.whatsapp_number && (
                  <a data-testid={`promo-offer-whatsapp-btn-${o.id}`} href={`https://wa.me/${o.whatsapp_number.replace(/\D/g, "")}?text=${encodeURIComponent(`Hi, I'm interested in: ${o.title}`)}`}
                    target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()}
                    className="inline-flex items-center gap-1.5 mt-2.5 text-xs font-semibold text-white bg-[#25D366] hover:bg-[#1ebe5b] px-3 py-1.5 rounded-full transition-colors">
                    <WhatsAppIcon size={13} /> WhatsApp Us
                  </a>
                )}
              </div>
            </div>
          );
          return o.link ? (
            <a key={o.id} href={o.link} target="_blank" rel="noreferrer" className="block">{card}</a>
          ) : card;
        })}
      </div>
    </section>
  );
}
